import React from "react";

function Pill({ btnStyle, children }) {
  return (
    <div
      className={`full-width flex j-c-center a-i-center h-40 b-r-5 ${btnStyle}`}
    >
      {children}
    </div>
  );
}

export default Pill;
